<template>
    <div id="app" class="desktop-view">
        <!-- 顶部导航栏 -->
        <header class="km-header" :class="{ 'is-scrolled': scrolled }">
            <div class="km-header__inner">
                <div class="km-brand" @click="handlerClick()">
                    <img src="https://qiniu.shunmingelectronic.com/guanwang/newLogo.png" alt="舜铭电子" class="km-brand__logo">
                    <img src="https://qiniu.shunmingelectronic.com/guanwang/shunming-text.png" alt="舜铭电子"
                        class="km-brand__name">
                </div>

                <nav class="km-nav">
                    <div class="km-nav__item">
                        <a href="#" class="km-nav__link" @click.prevent="handlerClick()">首页</a>
                    </div>
                    <div class="km-nav__item">
                        <a href="#" class="km-nav__link" @click.prevent="handlerClick('about')">关于我们</a>
                    </div>
                    <div class="km-nav__item">
                        <a href="https://shunmingelectronic.com/meter/" class="km-nav__link">流量计转换器</a>
                    </div>
                    <div class="km-nav__item">
                        <a href="https://shunmingelectronic.com/meter/project#/project" class="km-nav__link">仪表云平台</a>
                    </div>
                    <div class="km-nav__item" @mouseover="showDropdown('others')" @mouseleave="hideDropdown('others')">
                        <a href="#" class="km-nav__link" @click.prevent>其它产品</a>
                        <transition name="km-fade">
                            <div v-if="activeDropdown === 'others'" class="km-dropdown">
                                <a v-for="(product, index) in otherProducts" :key="index" href="#"
                                    @click.prevent="handlerClick('products', { categoryId: product.categoryId })">{{
                                        product.name }}</a>
                            </div>
                        </transition>
                    </div>
                    <div class="km-nav__item">
                        <a href="#" class="km-nav__link" @click.prevent="handlerClick('contact')">联系我们</a>
                    </div>
                </nav>

                <a href="#" class="km-btn km-btn-primary km-header__cta" @click.prevent="handlerClick('contact')">
                    开始合作
                </a>
            </div>
        </header>

        <!-- 路由视图 -->
        <main class="router-view-container">
            <router-view></router-view>
        </main>

        <!-- 页脚 -->
        <footer class="km-footer">
            <div class="km-container">
                <div class="km-footer__top">
                    <div class="km-footer__brand">
                        <div class="km-footer__brand-row">
                            <img src="https://qiniu.shunmingelectronic.com/guanwang/newLogo.png" alt="舜铭电子"
                                class="km-footer__logo">
                            <img src="https://qiniu.shunmingelectronic.com/guanwang/shunming-text.png" alt="舜铭电子"
                                class="km-footer__name">
                        </div>
                        <p class="km-footer__tagline">
                            精准智控，慧创未来。<br>为您提供物联网整体解决方案。
                        </p>
                    </div>
                    <div class="km-footer__links">
                        <div class="km-footer__col">
                            <span class="km-footer__heading">导航</span>
                            <a href="#" @click.prevent="handlerClick()">首页</a>
                            <a href="#" @click.prevent="handlerClick('about')">关于我们</a>
                            <a href="#" @click.prevent="handlerClick('contact')">联系我们</a>
                        </div>
                        <div class="km-footer__col">
                            <span class="km-footer__heading">产品</span>
                            <a href="https://shunmingelectronic.com/meter/">电磁流量计转换器</a>
                            <a href="https://shunmingelectronic.com/meter/project#/project">智控仪表数据云平台</a>
                            <a v-for="(product, index) in otherProducts" :key="index" href="#"
                                @click.prevent="handlerClick('products', { categoryId: product.categoryId })">{{
                                    product.name }}</a>
                        </div>
                        <div class="km-footer__col">
                            <span class="km-footer__heading">联系</span>
                            <span class="km-footer__muted">河南舜铭电子信息科技有限公司</span>
                            <span class="km-footer__muted">洛阳市高新区丰华路1号</span>
                            <span class="km-footer__muted">bright_xu@sina.cn</span>
                        </div>
                    </div>
                </div>

                <div class="km-footer__bottom">
                    <div class="km-footer__beian">
                        <a href="https://beian.miit.gov.cn">豫ICP备2024070819号-1</a>
                        <span class="km-footer__beian-gov">
                            <img src="../assets/batb.png" alt="" />
                            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41030502000977" rel="noreferrer">豫公网安备41030502000977</a>
                        </span>
                    </div>
                    <div class="km-footer__copy">{{ copyright }}</div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            gsxx: `ShunMing International`,
            copyright: '版权所有：河南舜铭电子信息科技有限公司 ©2024 ',
            activeDropdown: null,
            scrolled: false,
            otherProducts: [
                { name: '慧光路灯智能云平台', categoryId: 1 },
                { name: '传统行业物联网改造升级', categoryId: 3 }
            ]
        }
    },
    methods: {
        showDropdown(dropdownName) {
            this.activeDropdown = dropdownName;
        },
        hideDropdown(dropdownName) {
            if (this.activeDropdown === dropdownName) {
                this.activeDropdown = null;
            }
        },
        handlerClick(val, params) {
            let link = "/";
            if (val) link += val;
            this.$router.push({ path: link, query: params });
        },
        handleScroll() {
            this.scrolled = window.scrollY > 20;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style scoped>
.desktop-view {
    background: var(--bg);
    color: var(--text);
    min-height: 100vh;
}

/* ---------------- Header ---------------- */
.km-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    display: flex;
    justify-content: center;
    padding: 18px 24px;
    transition: padding 0.3s ease;
}

.km-header__inner {
    width: 100%;
    max-width: var(--maxw);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 10px 12px 10px 22px;
    border-radius: 999px;
    border: 1px solid transparent;
    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.km-header.is-scrolled .km-header__inner {
    background: rgba(255, 255, 255, 0.78);
    border-color: var(--border);
    box-shadow: 0 14px 40px rgba(15, 18, 24, 0.10);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
}

.km-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
}

.km-brand__logo {
    height: 48px;
    width: auto;
}

.km-brand__name {
    height: 22px;
    width: auto;
    display: block;
}

.km-nav {
    display: flex;
    align-items: center;
    gap: 6px;
}

.km-nav__item {
    position: relative;
}

.km-nav__link {
    display: inline-flex;
    align-items: center;
    height: 40px;
    padding: 0 12px;
    border-radius: 999px;
    text-decoration: none;
    color: var(--text-soft);
    font-family: var(--font-display);
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    transition: color 0.25s ease, background-color 0.25s ease;
}

.km-nav__item:hover .km-nav__link {
    color: var(--text);
    background: rgba(15, 18, 24, 0.05);
}

.km-dropdown {
    position: absolute;
    top: calc(100% + 14px);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    min-width: 220px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid var(--border);
    border-radius: 16px;
    box-shadow: 0 20px 50px rgba(15, 18, 24, 0.14);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
}

.km-dropdown::before {
    content: '';
    position: absolute;
    top: -14px;
    left: 0;
    right: 0;
    height: 14px;
}

.km-dropdown a {
    color: var(--text-soft);
    padding: 11px 14px;
    text-decoration: none;
    text-align: left;
    border-radius: 10px;
    font-size: 15px;
    white-space: nowrap;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.km-dropdown a:hover {
    background: rgba(15, 18, 24, 0.05);
    color: var(--text);
}

.km-header__cta {
    padding: 11px 22px;
    font-size: 15px;
}

.km-fade-enter-active,
.km-fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.km-fade-enter-from,
.km-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-6px);
}

/* ---------------- Router view ---------------- */
.router-view-container {
    position: relative;
    z-index: 1;
}

/* ---------------- Footer ---------------- */
.km-footer {
    background: var(--bg-soft);
    border-top: 1px solid var(--border);
    padding: 80px 0 36px;
    text-align: left;
}

.km-footer__top {
    display: flex;
    justify-content: space-between;
    gap: 60px;
    flex-wrap: wrap;
    padding-bottom: 56px;
    border-bottom: 1px solid var(--border);
}

.km-footer__brand {
    max-width: 320px;
}

.km-footer__brand-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
}

.km-footer__logo {
    height: 40px;
}

.km-footer__name {
    height: 22px;
    width: auto;
}

.km-footer__tagline {
    color: var(--text-soft);
    font-size: 15px;
    line-height: 1.7;
    margin: 0;
}

.km-footer__links {
    display: flex;
    gap: 64px;
    flex-wrap: wrap;
}

.km-footer__col {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.km-footer__heading {
    font-family: var(--font-display);
    font-size: 13px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--text-faint);
    margin-bottom: 6px;
}

.km-footer__col a {
    color: var(--text-soft);
    text-decoration: none;
    font-size: 15px;
    transition: color 0.2s ease;
}

.km-footer__col a:hover {
    color: var(--text);
}

.km-footer__muted {
    color: var(--text-soft);
    font-size: 15px;
}

.km-footer__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    padding-top: 28px;
}

.km-footer__beian {
    display: flex;
    align-items: center;
    gap: 22px;
    flex-wrap: wrap;
}

.km-footer__beian a {
    color: var(--text-faint);
    text-decoration: none;
    font-size: 13px;
    transition: color 0.2s ease;
}

.km-footer__beian a:hover {
    color: var(--text-soft);
}

.km-footer__beian-gov {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.km-footer__beian-gov img {
    width: 16px;
    height: 18px;
}

.km-footer__copy {
    color: var(--text-faint);
    font-size: 13px;
}

@media (max-width: 900px) {
    .km-nav {
        display: none;
    }

    .km-header__cta {
        display: none;
    }
}
</style>
